import { writable } from 'svelte/store'
import { mount } from 'svelte'

export const confirmStore = writable(null)

let hostMounted = false

const ensureHostMounted = () => {
  if (hostMounted || typeof document === 'undefined') return

  const target = document.createElement('div')
  document.body.appendChild(target)

  import('./confirm_dialog_host.svelte').then(({ default: ConfirmDialogHost }) => {
    mount(ConfirmDialogHost, { target })
  })

  hostMounted = true
}

// `variant` styles the confirm button ('error' for destructive actions).
export const confirm = ({ title, body, confirmLabel = 'Confirm', cancelLabel = 'Cancel', variant = 'primary' }) => {
  ensureHostMounted()

  return new Promise((resolve) => {
    confirmStore.set({ title, body, confirmLabel, cancelLabel, variant, resolve })
  })
}
